export enum RFQStatus {
  Open,
  Closed,
  Pending,
}

export const getRFQStatusString = (status: RFQStatus): string => {
  return RFQStatus[status];
};
